import React, { Fragment } from 'react';
import { useTranslate, required, SelectInput } from 'react-admin';
import { HiddenInput, SolutionSelect, MenuSelect } from '~/components/ra';

const l = (key: string): string => `resources.menu.fields.${key}`;

interface Props {
  edit?: boolean;
}

const MappingsForm = (props: Props) => {
  const { edit } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  return (
    <Fragment>
      {edit && <HiddenInput source='id' disabled />}
      <MenuSelect source='menuId' label={t('dynamicMenu')} helperText validate={required()} />
      <SelectInput
        source='channel'
        label={t('channel')}
        choices={[
          { id: 'MOBILE', name: translate('resources.menu.channels.MOBILE') },
          { id: 'WEB', name: translate('resources.menu.channels.WEB') },
          { id: 'WHATSAPP', name: translate('resources.menu.channels.WHATSAPP') },
          { id: 'USSD', name: translate('resources.menu.channels.USSD') },
          { id: 'MIDDLEWARE', name: translate('resources.menu.channels.MIDDLEWARE') },
          { id: 'OTHER', name: translate('resources.menu.channels.OTHER') },
        ]}
        emptyText={translate('utils.any')}
        allowEmpty
      />
      <SolutionSelect
        source='solutionId'
        label={t('solution')}
        helperText
        variant='all'
        allowEmpty
      />
    </Fragment>
  );
};

export default MappingsForm;
